import { NextImage } from "@components/NextImage/NextImage";
import { EventType, NFTEvent, NFTEventInfo } from "@models/event";
import { DEFAULT_LANGUAGE } from "@models/language";
import { User } from "@models/user";
import { isEmpty } from "lodash";
import { PlatinumBay } from "public";
import { useMemo } from "react";
import EventDetailAbout from "./EventDetailAbout";
import EventDetailBanner from "./EventDetailBanner";
import EventDetailEligibility from "./EventDetailEligibility";
import EventDetailFAQ from "./EventDetailFAQ";
import EventDetailHostInfo from "./EventDetailHostInfo";
import EventDetailInfo from "./EventDetailInfo";
import EventDetailTicketType from "./EventDetailTicketType";

const EventDetail = ({
  event,
  user,
}: {
  event: NFTEvent;
  user: User | null;
}) => {
  const language = DEFAULT_LANGUAGE;
  const info: NFTEventInfo = useMemo(() => {
    if (!event) return new NFTEventInfo({ name: "" });
    return event.localeInfo(language);
  }, [event, language]);

  const showAppNavBar = user && event.type === EventType.BENEFIT;

  return (
    <div className="container">
      <div className={`px-4 lg:px-0 ${showAppNavBar ? "" : "pt-8"}`}>
        <div className="text-[2rem] mb-8 dark:text-white flex flex-row items-center gap-2 justify-center md:justify-start">
          <NextImage
            className="w-[77px]"
            src={PlatinumBay}
            alt="platinum-bay"
          />
          <p
            style={{
              fontFamily: "Orbitron, medium",
              fontSize: "32px",
              color: "transparent",
              backgroundImage:
                "linear-gradient(175deg, rgb(0, 240, 255) 0%, rgb(38, 87, 212) 70%)",
              WebkitBackgroundClip: "text",
            }}
          >
            {info.name}
          </p>
          {info.subtitle && <p className="py-4 text-2xl">{info.subtitle}</p>}
        </div>

        <div
          className={`w-full h-full min-h-full flex flex-col md:flex-row md:justify-center px-4 lg:px-0 items-center`}
        >
          {/* Main Content */}
          <div className="w-full flex flex-col items-start flex-grow md:mr-10">
            <div className="flex md:hidden w-full">
              <EventDetailBanner event={event} info={info} />
            </div>

            <EventDetailInfo event={event} info={info} />

            <EventDetailTicketType event={event} />

            {event.type === EventType.BENEFIT && (
              <EventDetailEligibility event={event} user={user} />
            )}

            <EventDetailAbout />

            {!isEmpty(info.organizer) &&
              info.organizer.name &&
              info.organizer.description && <EventDetailHostInfo info={info} />}

            <EventDetailFAQ faqs={info.faqs} />
          </div>

          {/* Side Banner */}
          <div className="col-span-4 flex-shrink-0 min-h-0 hidden md:block sticky top-4 self-start w-[20rem] lg:w-[24rem] xl:w-[28rem] ">
            <EventDetailBanner event={event} info={info} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventDetail;
